import ExerciseList from "../components/ExerciseList";
import SearchBox from "../components/SearchBox";
import { useState, useEffect } from "react";
import { exerciseOptions, fetchData } from "../utils/fetchData";
import NotFound from "../components/NotFound";
import Loader from "../components/Loader";

export default function Exercise() {
  const [exerciseData, setExerciseData] = useState([]);
  const [selectedMuscle, setSelectedMuscle] = useState("Biceps");
  const [selectedIntensity, setSelectedIntensity] = useState("Beginner");
  const [searchedExercise, setSearchedExercise] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState(null);
  const fetchExerciseData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchData(
        "https://work-out-api1.p.rapidapi.com/search",
        exerciseOptions
      );
      if (!data) {
        throw new Error("Network response not ok");
      }
      console.log(data);
      setExerciseData(data);
      setIsLoading(false);
      setError(null);
    } catch (error) {
      console.error(error);
      setError("There is a problem with the network. Please try again later");
    }
  };

  useEffect(() => {
    fetchExerciseData();
  }, []);

  useEffect(() => {
    const output = exerciseData.filter((exercise) => {
      return (
        exercise.Muscles.includes(selectedMuscle) &&
        exercise.Intensity_Level.includes(selectedIntensity)
      );
    });

    setSearchedExercise(output);
  }, [selectedIntensity, selectedMuscle, exerciseData]);

  // console.log(searchedExercise);

  const muscles = Array.from(new Set(exerciseData.map((item) => item.Muscles)));
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <p className="text-center text-xl font-medium">{error}</p>
      ) : (
        <>
          <SearchBox
            muscles={muscles}
            setSelectedIntensity={setSelectedIntensity}
            setSelectedMuscle={setSelectedMuscle}
            selectedIntensity={selectedIntensity}
            selectedMuscle={selectedMuscle}
          />

          {!searchedExercise.length ? (
            <NotFound />
          ) : (
            <ExerciseList searchedExercise={searchedExercise} />
          )}
        </>
      )}
    </>
  );
}
